export * from 'server/models/BerthAmenity';


// WEBPACK FOOTER //
// ./data/models/BerthAmenity.ts